// extracted by mini-css-extract-plugin
export var box = "_6v-1";
export var checked = "_6v-2";
export var descriptionSpacer = "_6v-9";
export var disabled = "_6v-3";
export var icon = "_6v-6";
export var input = "_6v-0";
export var labelSpacer = "_6v-8";
export var medium = "_6v-5";
export var small = "_6v-4";
export var text = "_6v-7";